import { Type, plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { IRegisterItemPropertiesAttachments } from './IRegisterItemPropertiesAttachments'
import { RegisterItemAttachment } from './RegisterItemAttachment'

export class RegisterItemPropertiesAttachments extends Entity<IRegisterItemPropertiesAttachments> {
  propertyId: string
  propertyName: string

  @Type(() => RegisterItemAttachment)
  attachments: RegisterItemAttachment[]

  public static new(payload: unknown): RegisterItemPropertiesAttachments {
    return plainToInstance(RegisterItemPropertiesAttachments, payload)
  }
}
